// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"da702629","137":"da702629","239":"da702629","940":"da702629"}[chunkId] + ".chunk.css";
};